import { MenuIcon, SearchIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { isMacPlatform } from '@/shared/lib/dom';
import { useModuleRegistry } from '@/shared/registry/context';
import { Button } from '@/shared/ui/button';
import { Kbd } from '@/shared/ui/kbd';
import { Separator } from '@/shared/ui/separator';

import { PortalMark } from '../brand/OrbitaLogo';

import { useShellStore } from './shellStore';
import { UserMenu } from './UserMenu';

export function TopBar() {
  const { t } = useTranslation('app');
  const registry = useModuleRegistry();
  const setPaletteOpen = useShellStore((s) => s.setPaletteOpen);
  const setMobileNavOpen = useShellStore((s) => s.setMobileNavOpen);

  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-2 bg-surface/85 px-3 backdrop-blur-md supports-[backdrop-filter]:bg-surface/70 sm:px-4 lg:pr-4 lg:pl-0">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={() => setMobileNavOpen(true)}
        aria-label={t('nav.open')}
      >
        <MenuIcon />
      </Button>
      <PortalMark className="size-6 lg:hidden" />
      <button
        type="button"
        onClick={() => setPaletteOpen(true)}
        data-testid="search-trigger"
        className="group ml-1 flex h-9 min-w-0 flex-1 items-center gap-2.5 rounded-lg border border-transparent bg-transparent px-2.5 text-sm text-muted-foreground focus-ring transition-colors hover:border-border hover:bg-background sm:max-w-md sm:border-border sm:bg-background/60 lg:ml-0"
        aria-label={t('search.open')}
      >
        <SearchIcon className="size-4 shrink-0" />
        <span className="hidden truncate sm:inline">{t('search.placeholder')}</span>
        <span className="ml-auto hidden items-center gap-0.5 sm:flex">
          <Kbd>{isMacPlatform() ? '⌘' : 'Ctrl'}</Kbd>
          <Kbd>K</Kbd>
        </span>
      </button>
      <div className="ml-auto flex items-center gap-1">
        {registry.topBarWidgets.map(({ id, component: Widget }) => (
          <Widget key={id} />
        ))}
        {registry.topBarWidgets.length > 0 && <Separator orientation="vertical" className="mx-1.5 h-6" />}
        <UserMenu />
      </div>
    </header>
  );
}
